import React, { useEffect, useState } from 'react';
import { Stethoscope, Pill, ClipboardList, Syringe, ChevronDown, ChevronUp, Info, HeartPulse } from 'lucide-react';
import ToolHeader from '../shared/ToolHeader';
import { Section, Card } from '../hospital/shared/primitives';
import { DISCLAIMER_TEXT } from '../shared/ClinicalDisclaimer';
import ToolGrid from '../hospital/shared/ToolGrid';
import { trackClinicalToolView } from '../../utils/analyticsUtils';
import { notify } from '../../utils/notify';

const ACCENT = '#6d28d9';

const ClinicalToolsScreen = ({ onBack, onMedicationReferenceClick, onPreopGuideClick, onASRACoagsClick, onTeeCertificationClick }) => {
  useEffect(() => { trackClinicalToolView('Clinical Tools Hub'); }, []);
  const [aboutOpen, setAboutOpen] = useState(false);

  const actions = {
    'medication-reference': onMedicationReferenceClick,
    'asra-coags': onASRACoagsClick,
    'preop-guide': null, // not built yet
    'tee-certification': onTeeCertificationClick,
  };

  const tools = [
    { id: 'asra', title: 'Anticoagulation & Neuraxial', subtitle: 'Hold times by drug', icon: Syringe, action: 'asra-coags', featured: true },
    { id: 'meds', title: 'Medication Reference', subtitle: 'CV, OB, pediatric, regional', icon: Pill, action: 'medication-reference', featured: true },
    { id: 'preop', title: 'Preop Medications', subtitle: 'Hold or continue, by class', icon: ClipboardList, action: 'preop-guide', featured: true },
    { id: 'tee', title: 'Basic TEE Certification', subtitle: 'NBE requirements and your case log', icon: HeartPulse, action: 'tee-certification', featured: true },
  ];

  const run = (action) => {
    const fn = actions[action];
    if (!fn) { notify.info('Coming soon'); return; }
    trackClinicalToolView(action);
    fn();
  };

  return (
    <div className="max-w-md mx-auto bg-gray-50 dark:bg-gray-900 min-h-screen">
      <ToolHeader title="Clinical Tools" icon={Stethoscope} accent={ACCENT} backLabel="Home" onBack={onBack} />
      <div className="p-6 space-y-6">
        <Section title="Tools">
          <ToolGrid tools={tools} accent={ACCENT} onAction={run} />
        </Section>

        <Card>
          <button
            onClick={() => { setAboutOpen((o) => !o); }}
            aria-expanded={aboutOpen}
            className="w-full flex items-center gap-3 px-4 py-3 text-left"
          >
            <Info size={18} className="flex-shrink-0" style={{ color: ACCENT }} />
            <span className="flex-1 text-[15px] font-medium text-gray-900 dark:text-white">About Clinical Tools</span>
            {aboutOpen ? <ChevronUp size={18} className="text-gray-300 dark:text-gray-600" /> : <ChevronDown size={18} className="text-gray-300 dark:text-gray-600" />}
          </button>
          {aboutOpen && (
            <p className="px-4 py-3 text-sm leading-snug text-gray-700 dark:text-gray-300">{DISCLAIMER_TEXT}</p>
          )}
        </Card>
      </div>
      <div className="h-8" />
    </div>
  );
};

export default ClinicalToolsScreen;
